module.exports = __webpack_public_path__ + "static/media/connect-examples-section.af8b8949.svg";